import React from "react"
import { linkResolver } from "utils/linkResolver"
import { Icon } from "@mostlycode/ui"
import styled from "styled-components"
import Link from "../Link"
import Section from "../Section"
import CardContainer from "../CardContainer"
import ContentCard from "../ContentCard"

const StyledContentCard = styled(ContentCard)`
  p {
    margin-bottom: 0.5em;
  }
  p + p {
    margin-top: 0;
  }
`

function Articles({ articles, ...props }) {
  return (
    <Section align="center">
      <CardContainer equalize align="start">
        {articles.map(({ article }) => {
          const {
            id,
            summary,
            title,
            _meta: { lang },
          } = article
          const url = linkResolver(article._meta)
          return (
            <StyledContentCard size="md" bg="white" color="primary" key={id}>
              <h4>
                <Link to={url}>{title[0].text}</Link>
              </h4>
              <p>{summary}</p>
              <Link to={url}>
                {lang === "da-dk" ? "Læs artiklen" : "Read the post"}
                <Icon icon="long-arrow-right" />
              </Link>
            </StyledContentCard>
          )
        })}
      </CardContainer>
    </Section>
  )
}

export default Articles
